import { DashboardOutlined } from "@ant-design/icons";
import React, { lazy } from "react";
export const staticPathUnAuthen = {
    sensorMonitoring: "/sensor/monitoring"
};

const routeUnAuthens = [
    {
        path: staticPathUnAuthen.sensorMonitoring + "/:code",
        key: staticPathUnAuthen.sensorMonitoring + "/:code",
        exact: true,
        title: "Theo dõi cảm biến",
        icon: <DashboardOutlined />,
        component: lazy(() => import("../pages/sensor/sensorMonitoring")),
    },
];

function flatRouteConfig(routes) {
    let flatRoutes = [];
    Array.isArray(routes) &&
        routes.forEach((item) => {
            if (item.childrens) {
                flatRoutes.push(...item.childrens);
            } else {
                item.path && flatRoutes.push(item);
            }
        });
    return flatRoutes;
}

export const flatUnAuthenConfig = flatRouteConfig(routeUnAuthens);

export default routeUnAuthens;
